import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { login } from "@/lib/api";
import Logo from "@/components/Logo";
import SoftImage from "@/components/SoftImage";
import { Mail, Lock, ArrowRight, ShieldCheck } from "lucide-react";

export default function Login() {
  const nav = useNavigate();
  const [email, setEmail] = useState("carter@proactivebh.com");
  const [password, setPassword] = useState("demo1234");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await login({ email, password });
      localStorage.setItem("pbh_token", res.token);
      localStorage.setItem("pbh_user", JSON.stringify(res.user));
      toast.success(`Welcome back, ${res.user.name}!`);
      nav("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen pbh-page grid lg:grid-cols-2">
      <div className="flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <Logo height={52} />
          <h1 className="font-display mt-8 text-[32px] font-extrabold text-[#10233f]">Welcome back</h1>
          <p className="mt-2 text-slate-500">Sign in to your ProactiveBH care dashboard.</p>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <label className="text-sm font-semibold text-[#10233f]">Email</label>
              <div className="mt-1.5 flex items-center gap-2 card-soft px-4 py-3" style={{ borderRadius: 14 }}>
                <Mail size={18} className="text-slate-400" />
                <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="flex-1 outline-none text-[15px] bg-transparent" placeholder="you@clinic.com" />
              </div>
            </div>
            <div>
              <label className="text-sm font-semibold text-[#10233f]">Password</label>
              <div className="mt-1.5 flex items-center gap-2 card-soft px-4 py-3" style={{ borderRadius: 14 }}>
                <Lock size={18} className="text-slate-400" />
                <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="flex-1 outline-none text-[15px] bg-transparent" placeholder="••••••••" />
              </div>
            </div>
            <button data-testid="login-submit" disabled={loading} className="btn-primary w-full py-3.5 font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-60">{loading ? "Signing in…" : (<>Sign In <ArrowRight size={18} /></>)}</button>
          </form>
          <div className="mt-5 flex items-center gap-2 text-sm text-slate-500 bg-[#eef5ff] rounded-xl px-4 py-3"><ShieldCheck size={16} className="text-[#1a5fd0]" /> Demo login pre-filled — just click Sign In.</div>
          <p className="mt-6 text-sm text-slate-500">New to ProactiveBH? <Link to="/request-demo" className="text-[#1a5fd0] font-semibold">Request a demo</Link></p>
        </div>
      </div>
      <div className="relative hidden lg:block overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#1f5fd6] to-[#0f2a5e]" />
        <div className="relative h-full flex flex-col items-center justify-center p-12 text-white text-center">
          <SoftImage src="/generated/noah_wave.png" alt="Child" variant="strong" className="h-72 w-72 rounded-[32px]" imgClassName="rounded-[32px]" />
          <h2 className="font-display mt-8 text-[30px] font-extrabold leading-tight">Stronger Children,<br />Brighter Tomorrows</h2>
          <p className="mt-3 text-white/80 max-w-sm">Coordinate clinicians, families, and schools — all in one secure, HIPAA-compliant platform.</p>
          <div className="mt-4 font-hand text-[26px] text-white/90">Healthy Minds, Brighter Futures ♥</div>
        </div>
      </div>
    </div>
  );
}
